import { Injectable } from '@angular/core';
import { EntityStore, StoreConfig } from '@datorama/akita';

import { AuthLocationState } from './auth-location.state';

@Injectable({providedIn: 'root'})
@StoreConfig({ name: 'authLocations', resettable: true, idKey: '_id' })
export class AuthLocationStore extends EntityStore<AuthLocationState> {
  constructor() {
    super();
  }
}
